import { createSelector } from 'reselect'

const selectAcquiring = state => state.acquiring

export const selectAllAcquiring = createSelector([selectAcquiring], acquiring => acquiring)

export const selectAcquiringLoader = createSelector([selectAcquiring], acquiring => acquiring.loader)
export const selectAcquiringSuccess = createSelector([selectAcquiring], acquiring => acquiring.success)

export const selectAcquiringError = createSelector([selectAcquiring], acquiring => acquiring.error)

export const selectAcquiringErrorMessage = createSelector([selectAcquiring], acquiring => acquiring.errorMessage)

export const selectDefaultCardAcquiring = createSelector([selectAcquiring], acquiring => acquiring.defaultCardAcquiring)

export const selectAccountsAcquiring = createSelector([selectAcquiring], acquiring => acquiring.accountsAcquiring)

export const selectAcquiringTransfersDownload = createSelector([selectAcquiring], acquiring => acquiring.acquiringTransfersDownload)

export const selectCardAcquiringApiKey = createSelector([selectAcquiring], acquiring => acquiring.cardAcquiringApiKey)

export const selectCardAcquiringSettlements = createSelector([selectAcquiring], acquiring => acquiring.cardAcquiringSettlements)

export const selectCardAcquiringMerchantsInit = createSelector([selectAcquiring], acquiring => acquiring.cardAcquiringMerchantsInit)

export const selectCardAcquiringCharges = createSelector([selectAcquiring], acquiring => acquiring.cardAcquiringCharges)

export const selectAcquiringChargesDownload = createSelector([selectAcquiring], acquiring => acquiring.cardAcquiringChargesDownload)

export const selectSettlementsPdf = createSelector([selectAcquiring], acquiring => acquiring.settlementsPdf)

export const selectSettlementsCSV = createSelector([selectAcquiring], acquiring => acquiring.settlementsCSV)

export const selectSettlementsPeriodSummary = createSelector([selectAcquiring], acquiring => acquiring.settlementsPeriodSummary)

export const selectChargesReceiptPdf = createSelector([selectAcquiring], acquiring => acquiring.chargesReceiptPdf)
